var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2765",
    "data-name": "Rectangle 2765",
    width: 13,
    height: 11,
    transform: "translate(0.182 0.291)",
    fill: "#e7f0f4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10361",
    "data-name": "Group 10361",
    transform: "translate(-0.022 -0.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10360",
    "data-name": "Group 10360",
    transform: "translate(-0.16 -0.023)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27961",
    "data-name": "Path 27961",
    d: "M7.5,11.54a.576.576,0,0,1-.258-.061L4.935,10.325a.578.578,0,0,1-.319-.516V6.246L.136.949A.577.577,0,0,1,.577,0h11.54a.576.576,0,0,1,.44.949l-4.479,5.3v4.717a.576.576,0,0,1-.577.577M5.77,9.452l1.154.577V6.035a.571.571,0,0,1,.137-.372l3.813-4.508H1.821L5.634,5.662a.578.578,0,0,1,.136.372Z",
    transform: "translate(0.142 0.021)",
    fill: "#e7f0f4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.f804779702c520e72f2fc12c27ea669c.svg";
export { ForwardRef as ReactComponent };